/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Bank_CodeInputs */

const en_clients_field_bank_code = /** @type {(inputs: Clients_Field_Bank_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bank Code`)
};

const pt_br2_clients_field_bank_code = /** @type {(inputs: Clients_Field_Bank_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do Banco`)
};

/**
* | output |
* | --- |
* | "Bank Code" |
*
* @param {Clients_Field_Bank_CodeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_bank_code = /** @type {((inputs?: Clients_Field_Bank_CodeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Bank_CodeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_bank_code(inputs)
	return pt_br2_clients_field_bank_code(inputs)
});